<template>
  <div class="bc variable-textarea">
    <at-ta :ats="activator" :members="variables" ref="atTextarea">
      <v-textarea
        label="Nachricht Template"
        :value="value"
        :hint="hint"
        :persistent-hint="persistentHint"
        :outline="outline"
        ref="textarea"
        @keypress.enter.prevent="addVariable"
        @blur="onBlur"
        @input="onInput"
      ></v-textarea>
    </at-ta>
  </div>
</template>

<script>
// npm i vue-at textarea-caret
import AtTa from 'vue-at/dist/vue-at-textarea';

export default {
  name: 'variable-textarea',

  components: {
    AtTa,
  },

  props: {
    label: {
      type: String,
      default: 'Label',
    },
    variables: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
    activator: {
      type: Array,
      default: () => ['$'],
    },
    outline: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      valueModel: '',
    };
  },

  methods: {
    addVariable() {
      const newValue = this.valueModel + this.$refs.atTextarea.currentItem.substr(1);
      this.$emit('input', newValue);
      this.$refs.atTextarea.closePanel();
    },
    onInput(e) {
      this.valueModel = e;
      this.$emit('input', this.valueModel);
    },
    onBlur() {
      this.$refs.atTextarea.closePanel();
    },
  },
};
</script>
